
import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoginPage from '@/pages/LoginPage';
import { useAuth } from '@/contexts/AuthContext';
import { useDebouncedValue } from '@/hooks/use-debounced-value';

/**
 * Компонент, содержащий публичные маршруты с проверкой авторизации
 */
export const PublicRoutes: React.FC = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const redirectAttempted = useRef<boolean>(false);
  
  // Дебаунсим состояние пользователя для предотвращения частых изменений
  const debouncedUser = useDebouncedValue(user, 300);
  const debouncedIsLoading = useDebouncedValue(isLoading, 300);
  
  // Сбрасываем флаг при изменении пути
  useEffect(() => {
    redirectAttempted.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // Отладочная информация
  console.log(`PublicRoutes: путь=${location.pathname}, пользователь=${!!debouncedUser}, загрузка=${debouncedIsLoading}`);
  
  // Если пользователь авторизован и загрузка завершена
  if (debouncedUser && !debouncedIsLoading) {
    // Предотвращаем множественные редиректы
    if (!redirectAttempted.current) {
      redirectAttempted.current = true;
      console.log(`PublicRoutes: Редирект на / с ${location.pathname}`);
      
      // Исключаем перенаправление с /login для предотвращения циклов
      if (location.pathname === "/login") {
        return <Navigate to="/" replace />;
      }
    }
  }
  
  // Показываем компонент загрузки во время проверки авторизации
  if (debouncedIsLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        <div className="ml-3">Загрузка...</div>
      </div>
    );
  }

  // Показываем страницу входа для неавторизованных пользователей
  return <LoginPage />;
};
